export default __webpack_public_path__ + "static/media/setup-device-feature.25a55b2d.png";